module.exports = __webpack_public_path__ + "static/media/car.5aa032f7.jpg";